// appsActions.js
import {
  ADD_RECENTLY_APP,
  REMOVE_RECENTLY_APP,
  INIT_RECENTLY_APP
} from '../types/recentlyAppConstants'

export function initRecentlyOpenedApp(items) {
  return {
    type: INIT_RECENTLY_APP,
    payload: items
  }
}

export function addRecentlyApp(item) {
  return {
    type: ADD_RECENTLY_APP,
    payload: item
  }
}

export function removeRecentlyApp(item) {
  return {
    type: REMOVE_RECENTLY_APP,
    payload: item
  }
}
